/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {TitleOutlined} from "@mui/icons-material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import IngresoImagenLista from "../../Modulo_formularios/Componentes/IngresoImagenLista";


const Formulario_Sos_Galeria = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={12}>
                    <IngresoTexto Icono={TitleOutlined} nombre={'Nombre del post'}
                                  dato={'nombre'} {...props} editable={false}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Galeria de fotos (peso menor a 300k)</Typography>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresoImagenLista {...props} dato={'imgs'}/>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Sos_Galeria